module.exports = __webpack_public_path__ + "front/img/b22.e5945ccb.jpg";